import React, { forwardRef } from 'react';

import { Input } from '../Input';
import { IInputProps } from '../Input';

export interface ITextInputProps extends Omit<IInputProps, 'type'> {
    type?: 'text' | 'password' | 'email' | 'url';
}

export const TextInput = forwardRef<HTMLInputElement, ITextInputProps>(({ type = 'text', ...props }, ref) => {
    return <Input type={type} {...props} ref={ref} />;
});
